import { render, staticRenderFns } from "./makeSurePas.vue?vue&type=template&id=d1c50484&scoped=true"
import script from "./makeSurePas.vue?vue&type=script&lang=js"
export * from "./makeSurePas.vue?vue&type=script&lang=js"
import style0 from "./makeSurePas.vue?vue&type=style&index=0&id=d1c50484&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c50484",
  null
  
)

export default component.exports